module.exports = __webpack_public_path__ + "media/icons/approver-8f8b0839.svg";